import { getLocalGatewayStatus, subscribeLocalGatewayStatus, } from '@/lib/localGateway/status';
import { useSyncExternalStore } from 'react';
/**
 * Whether this window's images are coming from the clinic's onsite node or from
 * the cloud, and why.
 *
 * The store hands back the same snapshot object until something observable
 * changes, so this re-renders on a real transition (probe settles, breaker
 * trips, permission flips, override set) and not on the probe traffic in
 * between. There is no server state and no fetching here: the verdict is
 * produced by lib/localGateway as a side effect of loading images.
 */
export function useLocalGatewayStatus() {
    return useSyncExternalStore(subscribeLocalGatewayStatus, getLocalGatewayStatus);
}
